import { RadioGroupItemProps, RadioGroupProps } from '@nx-ng/types';

export const determineFareSelectorRadioGroup = ({
  itemGroup,
  validIds,
  selectedValue,
}: {
  itemGroup?: RadioGroupItemProps<string>[];
  validIds: string[];
  selectedValue?: string;
}) => {
  if (!itemGroup) {
    return undefined;
  }

  return itemGroup
    .filter(
      (lookupValues: RadioGroupItemProps<string>) =>
        validIds.includes(lookupValues.value) ||
        selectedValue === lookupValues.value
    )
    .map((item: RadioGroupItemProps<string>) => {
      return {
        ...item,
        isInvalid:
          item.value === selectedValue && !validIds.includes(item.value),
      };
    });
};

export const determineFareSelectorRadioOptions = ({
  allOptions,
  validIds,
  selectedValue,
}: {
  allOptions: RadioGroupProps<string>;
  validIds: string[];
  selectedValue?: string;
}) => {
  const items: RadioGroupProps<string> = {
    ...allOptions,
    standard:
      determineFareSelectorRadioGroup({
        validIds,
        selectedValue,
        itemGroup: allOptions.standard,
      }) || [],
    additional: determineFareSelectorRadioGroup({
      validIds,
      selectedValue,
      itemGroup: allOptions.additional,
    }),
  };
  return items;
};
